import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import {
  Button,
  Modal,
  Search,
  Label,
  Table,
  Tab,
  TabPane,
} from "semantic-ui-react";
import MDL_PROGRESS from "../../../components/cmp-progress/cmp-progress";
import "./reports.css";
import { getSchedulerReports, postSchedulerReport } from "../../../constants";
import AppPagination from "../../../components/cmp-pagination/Pagination";
import XLSXUPLOADER from "../../../components/cmp-xlsxuploder/cmp-xlsxuploder";
import { AppContext } from "../../../Context/AppContext";
import { useToasts } from "react-toast-notifications";

export default function Reports() {
  /* VARIABLE DECLARATIONS
	---------------------------------------------------------------------------------*/
  const { userInfo, appVersion, isAppVersionOutdated } = useContext(AppContext);
  const [user] = userInfo;
  const [var_app_version] = appVersion;
  const [, set_is_app_version_outdated] = isAppVersionOutdated;
  const [schedulerReport, setSchedulerReport] = useState([]);
  const [page, setPage] = useState(1);
  const [filter, setFilter] = useState("invalid_comments");
  const [limit, setLimit] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  const [var_mdl_progress, set_mdl_progress] = useState(false);
  const [var_mdl_uploadxlsx_open, set_mdl_uploadxlsx_open] = useState(false);
  const [var_change_pane, set_change_pane] = useState(0);

  const { addToast } = useToasts();

  /* EVENT LISTENERS
	=================================================================================*/
  useEffect(() => {
    if (searchQuery === "") {
      getallSchedulerReports(page, limit, searchQuery);
    }
  }, [page, limit, filter, searchQuery, var_mdl_uploadxlsx_open]);

  useEffect(() => {
    if (var_change_pane === 0) {
      setPage(1);
      getallSchedulerReports(1, limit, searchQuery);
    }
  }, [var_change_pane]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(async () => {
      if (searchQuery > 0) {
        getallSchedulerReports(1, limit, searchQuery);
      }
    }, 1200);

    return () => clearTimeout(delayDebounceFn);
  }, [searchQuery]);

  /* Async functions
	---------------------------------------------------------------------------------*/
  /**
   *
   * @param {*} page_no will be the specific page on which you want to go
   * @param {*} limit_range how much records you need in a call
   * @param {*} q if there is any search text
   */
  async function getallSchedulerReports(page_no, limit_range, q) {
    var query_params = "";
    if (q) {
      query_params = `?q=${q}&page=${page_no ? page_no : page}&limit=${
        limit_range ? limit_range : limit
      }`;
    } else {
      query_params = `?page=${page_no ? page_no : page}&limit=${
        limit_range ? limit_range : limit
      }`;
    }
    const requestHeaders = {
      headers: {
        entityid: user.uuid,
        appversion: var_app_version,
      },
    };
    set_mdl_progress(true);
    await fetch(getSchedulerReports + query_params, requestHeaders)
      .then((response) => response.json())
      .then((res) => {
        var reportFetch = [];
        const { data } = res.body;
        console.log("data", data);
        //setTotalBuildings(res.total_building);
        if (res.statusCode === 200) {
          reportFetch = data;
          if (data.length === 0) {
            //setPage(page-1);
          }
        } else {
          if (res?.version && res?.version !== var_app_version) {
            set_is_app_version_outdated(true);
          }
          reportFetch = [];
        }

        if ((page && page > 1) || (page_no && page_no > 1))
          reportFetch = [...schedulerReport, ...reportFetch];
        setSchedulerReport(reportFetch);
        set_mdl_progress(false);
      })
      .catch((error) => {
        console.error("Error building get:", error);
        set_mdl_progress(false);
      });
  }

  async function downloadReport(data) {
    const url = `${getSchedulerReports}?uuid=${data.id}&download=true&entityid=${user.uuid}`;
    try {
      window.open(url, "_blank");
    } catch (error) {
      console.error("Error:", error);
    }
  }

  /* EVENT FUNCTIONS
	=================================================================================*/
  /**
   * We will get the text from the search and send it in our APi call
   * @param {*} event on search text change event
   */
  function doSearch(event) {
    const value = event.target.value.toString().toLowerCase();
    setSearchQuery(value);
  }

  const handleTabChange = (e, { activeIndex }) => {
    set_change_pane(activeIndex); // Update active tab index
  };

  const openUploadXLSXModal = () => {
    set_mdl_uploadxlsx_open(true); // Open the modal
  };

  const panes = [
    {
      menuItem: {
        key: "schedulerReports",
        icon: "chart bar",
        content: "Scheduler Reports",
      },
      render: () => (
        <>
          <TabPane>
            <div className="app-building-container">
              <div className="app-content-action">
                {/* Action button against this page */}
                <div className="app-content-action-right">
                  <Button color="orange" onClick={() => openUploadXLSXModal()}>
                    <img src="/bulk-upload.svg" alt="icon" />
                    Upload Scheduler Report
                  </Button>
                </div>
              </div>

              <div className="app-card">
                <div className="app-card-header building-managment-header-card">
                  <div className="app-card-title">
                    Scheduler Reports ({schedulerReport.length})
                  </div>
                  {/* <div className="app-content-search">
                <Search
                  placeholder="Search here (report name)"
                  onSearchChange={doSearch}
                  // minCharacters={20000}
                  showNoResults={false}
                  value={searchQuery}
                />
              </div> */}
                </div>

                <div className="app-table-wrapper">
                  <Table unstackable>
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell>Name</Table.HeaderCell>
                        <Table.HeaderCell>Created By</Table.HeaderCell>
                        <Table.HeaderCell>Created On</Table.HeaderCell>
                        <Table.HeaderCell textAlign="center">
                          Actions
                        </Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>

                    <Table.Body>
                      {!var_mdl_progress &&
                        schedulerReport?.map((data, i) => (
                          <Table.Row key={i}>
                            <Table.Cell>{data.filename}</Table.Cell>
                            <Table.Cell>{data.created_by}</Table.Cell>
                            <Table.Cell>
                              {moment(data.created_on).format("YYYY-MM-DD")}
                            </Table.Cell>
                            <Table.Cell
                              className="td-action"
                              collapsing
                              textAlign="right"
                            >
                              <Label
                                color="blue"
                                onClick={() => downloadReport(data)}
                              >
                                Download Report
                              </Label>
                            </Table.Cell>
                          </Table.Row>
                        ))}
                    </Table.Body>
                  </Table>
                  {!var_mdl_progress && schedulerReport.length === 0 && (
                    <div className="nodata-placeholder">
                      There is no report to display
                    </div>
                  )}
                </div>
              </div>
              <AppPagination
                limit={limit}
                setLimit={setLimit}
                page={page}
                setPage={setPage}
                rowsTotal={schedulerReport.length}
              />
            </div>{" "}
          </TabPane>
        </>
      ),
    },
  ];

  /* RENDER APP
	=================================================================================*/

  return (
    <>
      <div className="app-content">
        <Tab
          panes={panes}
          activeIndex={var_change_pane}
          onTabChange={handleTabChange}
        />

        {/***** MODAL: CSVUPLOADER **************************************************************************/}
        <Modal
          id="mdl-upload-xlsx"
          className="mdl-upload-xlsx"
          dimmer={"inverted"}
          open={var_mdl_uploadxlsx_open}
          onClose={() => set_mdl_uploadxlsx_open(false)}
        >
          <XLSXUPLOADER
            set_mdl_open={set_mdl_uploadxlsx_open}
            api_path={postSchedulerReport}
            var_modaltitle={"Upload Scheduler Report"}
          />
        </Modal>
        {/***** END MODAL: CSVUPLOADER **************************************************************************/}
        {/***** MODAL: PROGRESS **************************************************************************/}
        <Modal
          id="mdl-progress"
          dimmer={"inverted"}
          open={var_mdl_progress}
          closeOnDimmerClick={false}
          closeOnEscape={false}
          onClose={() => {}}
        >
          <MDL_PROGRESS
            set_mdl_open={set_mdl_progress}
            var_modaltitle="Please wait"
            var_message={"Stay on this page until this process finish."}
          ></MDL_PROGRESS>
        </Modal>

        {/***** END MODAL: PROGRESS **************************************************************************/}
      </div>
    </>
  );
}
